import UtilityService from "../services/UtillityServices/UtilityService";

const useCorsoConfigTable = () => {
  return [
    { key: 'denominazione', label: 'Denominazione' },
    { key: 'codice', label: 'Codice' },
    { key: 'modalita_erogazione', label: 'Modalità erogazione', 
      formatter: (value) => UtilityService.getModalitaErogazione(value) || "Nessuna" },
    { key: 'numero_massimo_corsisti', label: 'Numero massimo corsisti' },
/*     { key: 'data_inizio', label: 'Data inizio', 
      formatter: (value) => value ? UtilityService.formatDate(value) : "Nessuna" },
    { key: 'data_fine', label: 'Data fine', 
      formatter: (value) => value ? UtilityService.formatDate(value) : "Nessuna" }, */
 /*    { key: 'attivo', label: 'Stato', 
      formatter: (value) => value === 0 ? "Inattivo" : "Attivo" }, */
  ];
};

export default useCorsoConfigTable;
